export * from './accessInfoDossier.component';
